import React, { useState, useContext } from "react";
import {
    Col,
    Form,
    Row,
    Tooltip,
    OverlayTrigger,
    Tab,
    Nav
} from "react-bootstrap";
import {
    faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import NotyfContext from "../../contexts/NotyfContext.js";
import {
    HelpTooltip, redirectURL
} from "../../assets/functions.js";
import PopoverPicker from "../PopoverPicker.js";
import { BackgroundFormComponent } from '../../components/Applications'

const SignaturePanel = ({
    fonts,
    handleChange,
    values,
    setFieldValue,
    errors,
    touched,
    handlePreviewSuccess,
    handlePreviewError,
    dataTable,
    setDataAddForm,
    dataAddForm,
    setModal,
    applications
}) => {
    const notyf = useContext(NotyfContext);
    const [activeTab, setActiveTab] = useState('panel');
    const [props, setProps] = useState({
        backgroundColor: values.json.apresentation?.textSide?.background.color,
        textColor: values.json.apresentation?.textSide?.textColor,
        penColor: values.json.appState?.penColor?.value
    });

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Definições</h5>
            </Form.Group>
            <Row className="mx-0 mb-3">
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12">
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        type="text"
                        name="titulo"
                        value={values.titulo}
                        onChange={handleChange}
                        isInvalid={!!errors.titulo}
                        isValid={touched.titulo && !errors.titulo}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.titulo}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">
                    Participante
                </h5>
            </Form.Group>
            <Row className="mx-0 mb-3">
                <Form.Group
                    as={Col}
                    md="6"
                    className="mx-0 mb-3">
                    <Form.Label>Tipo de exibição <OverlayTrigger overlay={<Tooltip>Usuário: Cada usuário vê apenas suas próprias assinaturas. Painel: Exibe todas as assinaturas flutuantes</Tooltip>}><HelpTooltip icon={faExclamationCircle} /></OverlayTrigger></Form.Label>
                    <Form.Select
                        onChange={handleChange}
                        name="json.displayMode.value"
                        value={values.json.displayMode?.value}>
                        <option value={'user'}>
                            Usuário
                        </option>
                        <option value={'totem'}>
                            Totem
                        </option>
                    </Form.Select>
                </Form.Group>
                <div className="mb-3">
                    <div className="d-flex text-start">
                        <Form.Group sm={6}>
                            <Form.Check
                                checked={values.json.allowMultipleSubmissions?.status === true ? true : false}
                                type="checkbox"
                                name="json.allowMultipleSubmissions.status"
                                label="Permitir múltiplos envios por usuário"
                                onChange={(e) => {
                                    setFieldValue(
                                        "json.allowMultipleSubmissions.status",
                                        e.target.checked
                                    );
                                }}
                            />
                        </Form.Group>
                    </div>
                </div>

            </Row>
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2">Configurações da assinatura</p>
                <Form.Group as={Col} sm={4} className='mb-3'>
                    <Form.Label>Espessura da caneta</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.appState.penWidth.value"
                        value={values.json.appState?.penWidth?.value}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.appState?.penWidth?.value}
                        min={1}
                        max={20}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.appState?.penWidth?.value}
                    </Form.Control.Feedback>
                </Form.Group>
                <div className="col-md-4 mb-3">
                    <Form.Label>Cor da caneta</Form.Label>
                    <div className={`d-flex justify-content-start align-items-center ${errors?.json?.appState?.penColor?.value ? 'is-invalid' : ''}`}>
                        <Form.Control
                            type="hidden"
                            name="json.appState.penColor.value"
                            value={values.json?.appState?.penColor?.value}
                            isInvalid={!!errors?.json?.appState?.penColor?.value}
                            isValid={touched?.json?.appState?.penColor?.value && !errors?.json?.appState?.penColor?.value}
                        />
                        <PopoverPicker
                            color={props.penColor}
                            onChangeX={(e) => {
                                setFieldValue("json.appState.penColor.value", e);
                                setProps(prevState => ({
                                    ...prevState,
                                    penColor: e
                                }));
                            }}
                            classes={`me-1 picker ${errors?.json?.appState?.penColor?.value ? 'is-invalid' : ''}`}
                        />
                    </div>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.appState?.penColor?.value ? errors?.json?.appState?.penColor?.value : ''}
                    </Form.Control.Feedback>
                </div>
            </Row>
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2">Tela inicial</p>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"
                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as="textarea"
                        name="json.title.value"
                        value={values.json.title.value}
                        onChange={(e) => {
                            if (e.target.value === '') {
                                setFieldValue("json.title.status", false);
                            } else {
                                setFieldValue("json.title.status", true);
                            }
                            setFieldValue("json.title.value", e.target.value);
                        }}
                        isInvalid={!!errors?.json?.title?.value}
                        isValid={touched?.json?.title?.value && !errors.json?.title?.value}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.title?.value}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"
                >
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                        as="textarea"
                        name="json.description.value"
                        value={values.json.description.value}
                        onChange={(e) => {
                            if (e.target.value === '') {
                                setFieldValue("json.description.status", false);
                            } else {
                                setFieldValue("json.description.status", true);
                            }
                            setFieldValue("json.description.value", e.target.value);
                        }}
                        isInvalid={!!errors?.json?.description?.value}
                        isValid={touched?.json?.description?.value && !errors.json?.description?.value}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.description?.value}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2">Tela final</p>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"
                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as="textarea"
                        name="json.endPage.title.value"
                        value={values.json.endPage?.title?.value || ''}
                        onChange={(e) => {
                            const nextValue = e.target.value;
                            setFieldValue("json.endPage.title.status", nextValue !== '');
                            setFieldValue("json.endPage.title.value", nextValue);
                        }}
                        isInvalid={!!errors?.json?.endPage?.title?.value}
                        isValid={touched?.json?.endPage?.title?.value && !errors?.json?.endPage?.title?.value}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.endPage?.title?.value}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"
                >
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                        as="textarea"
                        name="json.endPage.description.value"
                        value={values.json.endPage?.description?.value || ''}
                        onChange={(e) => {
                            const nextValue = e.target.value;
                            setFieldValue("json.endPage.description.status", nextValue !== '');
                            setFieldValue("json.endPage.description.value", nextValue);
                        }}
                        isInvalid={!!errors?.json?.endPage?.description?.value}
                        isValid={touched?.json?.endPage?.description?.value && !errors?.json?.endPage?.description?.value}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.endPage?.description?.value}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Modo apresentação</h5>
            </Form.Group>
            <Row className="mx-0">
                <Form.Group
                    as={Col}
                    md={4}
                    className="mb-3"
                >
                    <Form.Label>Tamanho fonte (M) (rem)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.h5"
                        step={"0.01"}
                        value={values.json.apresentation?.textSide?.h5}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.h5}
                        isValid={touched.json?.apresentation?.textSide?.h5 && !errors.json?.apresentation?.textSide?.h5}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.h5}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    as={Col}
                    md={4}
                    className="mb-3"
                >
                    <Form.Label>Tamanho fonte (P) (rem)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.p"
                        step={"0.01"}
                        value={values.json.apresentation?.textSide?.p}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.p}
                        isValid={touched.json?.apresentation?.textSide?.p && !errors.json?.apresentation?.textSide?.p}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.p}
                    </Form.Control.Feedback>
                </Form.Group>
                <div className="col-md-3 mb-3">
                    <Form.Label>Cor do texto</Form.Label>
                    <div className={`d-flex justify-content-start align-items-center ${errors?.json?.apresentation?.textSide?.textColor ? 'is-invalid' : ''}`}>
                        <Form.Control
                            type="hidden"
                            name="json.apresentation.textSide.textColor"
                            value={values.json?.apresentation?.textSide?.textColor}
                            isInvalid={!!errors?.json?.apresentation?.textSide?.textColor}
                            isValid={touched?.json?.apresentation?.textSide?.textColor && !errors?.json?.apresentation?.textSide?.textColor}
                        />
                        <PopoverPicker
                            color={props.textColor}
                            onChangeX={(e) => {
                                setFieldValue("json.apresentation.textSide.textColor", e);
                                setProps(prevState => ({
                                    ...prevState,
                                    textColor: e
                                }));
                            }}
                            classes={`me-1 picker ${errors?.json?.apresentation?.textSide?.textColor ? 'is-invalid' : ''}`}
                        />
                    </div>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.apresentation?.textSide?.textColor ? errors?.json?.apresentation?.textSide?.textColor : ''}
                    </Form.Control.Feedback>
                </div>
            </Row>
            <Row className="mx-0 mb-3">
                <Form.Group
                    as={Col}
                    md="6">
                    <Form.Label>Tipo de layout</Form.Label>
                    <Form.Select
                        onChange={(e) => {
                            // eslint-disable-next-line eqeqeq
                            if (e.target.value == 2) {
                                setFieldValue(
                                    "json.apresentation.imageSide.value", 40
                                );
                                setFieldValue(
                                    "json.apresentation.textSide.value", 60
                                );
                            } else {
                                setFieldValue(
                                    "json.apresentation.imageSide.value", 0
                                );
                                setFieldValue(
                                    "json.apresentation.textSide.value", 100
                                );
                            }
                        }}
                        value={values.json.apresentation?.imageSide?.value && values.json.apresentation?.imageSide?.value > 0 ? 2 : 1}>
                        <option value={1}>
                            Simples
                        </option>
                        <option value={2}>
                            Com banner
                        </option>
                    </Form.Select>
                </Form.Group>
            </Row>
            {
                values.json.apresentation.imageSide?.value > 0 &&
                <>
                    <Row className="mx-0 mb-3">
                        <Form.Group
                            as={Col}
                            md="3"
                            className="mb-3"
                        >
                            <Form.Label>Tamanho do banner (%)</Form.Label>
                            <Form.Control
                                type="number"
                                name="json.apresentation.imageSide.value"
                                value={values.json.apresentation?.imageSide?.value}
                                onChange={(e) => {
                                    if (e.target.value === undefined || e.target.value === '') {
                                        e.target.value = 0
                                    }
                                    let textSideValue = 100 - e.target.value
                                    setFieldValue("json.apresentation.imageSide.value", e.target.value);
                                    setFieldValue("json.apresentation.textSide.value", textSideValue);
                                }}
                                isInvalid={!!errors.json?.apresentation?.imageSide?.value}
                                isValid={touched.json?.apresentation?.imageSide?.value && !errors.json?.apresentation?.imageSide?.value}
                            />
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {errors.json?.apresentation?.imageSide?.value}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group
                            as={Col}
                            md="3"
                            className="mb-3"
                        >
                            <Form.Label>Posição</Form.Label>
                            <Form.Select
                                onChange={handleChange}
                                name="json.apresentation.imageSide.position"
                                value={values.json.apresentation?.imageSide?.position}>
                                <option value={'start'}>
                                    Esquerda
                                </option>
                                <option value={'end'}>
                                    Direita
                                </option>
                            </Form.Select>
                        </Form.Group>
                    </Row>
                </>
            }

            <Row className="mx-0 mb-3">
                <Form.Group
                    as={Col}
                    md="6">
                    <Form.Label>Tipo de plano de fundo {values.json.apresentation.textSide.background.type === 'color' && <OverlayTrigger
                        overlay={<Tooltip><b>Exemplo: </b>linear-gradient(90deg,rgba(42, 123, 155, 1) 0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%)</Tooltip>}
                    >
                        <span className="badge text-dark bg-light cursor-pointer ms-1" onClick={() => redirectURL(true, 'https://cssgradient.io/')}>CSS Gradient</span>
                    </OverlayTrigger>}</Form.Label>
                    <Form.Select
                        name="json.apresentation.textSide.background.type"
                        onChange={handleChange}
                        value={values.json.apresentation.textSide.background.type}
                        isInvalid={!!errors.json?.apresentation?.textSide?.background?.type}
                        isValid={touched.json?.apresentation?.textSide?.background?.type && !errors.json?.apresentation?.textSide?.background?.type}>
                        <option value={"color"}>
                            Cor
                        </option>
                        <option value={"image"}>
                            Imagem
                        </option>
                    </Form.Select>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">{errors.json?.apresentation?.textSide?.background?.type}</Form.Control.Feedback>
                </Form.Group>
            </Row>
            {values.json?.apresentation?.textSide?.background?.type !== 'color' ? <Row className="mb-3 mx-0">
                <BackgroundFormComponent touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} handlePreviewSuccess={handlePreviewSuccess} handlePreviewError={handlePreviewError}></BackgroundFormComponent>
            </Row> :
                <Row className="mx-0 mb-3">
                    <div className="col-md-3 mb-3">
                        <div className={`d-flex justify-content-start align-items-center ${errors?.json?.apresentation?.textSide?.background?.color ? 'is-invalid' : ''}`}>
                            <Form.Control
                                type="hidden"
                                name="json.apresentation.textSide.background.color"
                                value={values.json.apresentation.textSide.background.color}
                                isInvalid={!!errors?.json?.apresentation?.textSide?.background?.color}
                                isValid={touched?.json?.apresentation?.textSide?.background?.color && !errors?.json?.apresentation?.textSide?.background?.color}
                            />
                            <PopoverPicker
                                color={props.backgroundColor}
                                onChangeX={(e) => {
                                    setFieldValue("json.apresentation.textSide.background.color", e);
                                    setProps(prevState => ({
                                        ...prevState,
                                        backgroundColor: e
                                    }));
                                }}
                                classes={`me-1 picker ${errors?.json?.apresentation?.textSide?.background?.color ? 'is-invalid' : ''}`}
                            />
                        </div>
                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                            {errors?.json?.apresentation?.textSide?.background?.color ? errors?.json?.apresentation?.textSide?.background?.color : ''}
                        </Form.Control.Feedback>
                    </div>
                </Row>
            }
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2">Logomarca</p>
                <Form.Group as={Col} sm={6} className='mb-3'>
                    <Form.Label>Largura da logomarca (px)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.configs.logoSize"
                        value={values.json.apresentation.configs.logoSize}
                        onChange={(e) => {
                            handleChange(e);
                        }}
                        isInvalid={!!errors.json?.apresentation?.configs?.logoSize}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.configs?.logoSize}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Row className="mx-0 mb-3">
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"
                >
                    <Form.Check
                        checked={values.json.apresentation?.showQRCode?.status === true ? true : false}
                        type="checkbox"
                        name="json.apresentation.showQRCode.status"
                        label="Mostrar QRCode"
                        onChange={(e) => {
                            setFieldValue(
                                "json.apresentation.showQRCode.status",
                                values.json.apresentation.showQRCode?.status === true ? false : true
                            );
                        }}
                    />
                    {values.json.apresentation?.showQRCode?.status === true ? (
                        <Row>
                            <Form.Group
                                className="mb-3"
                                as={Col}
                                sm="4"
                            >
                                <Form.Label>Texto</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="json.apresentation.showQRCode.text"
                                    value={values.json.apresentation.showQRCode.text}
                                    onChange={handleChange}
                                    isInvalid={!!errors.apresentation?.showQRCode?.text}
                                    isValid={
                                        touched.json?.apresentation?.showQRCode?.text &&
                                        !errors.json?.apresentation?.showQRCode?.text
                                    }
                                />
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.text}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                as={Col}
                                sm="4"
                            >
                                <Form.Label>URL<OverlayTrigger overlay={<Tooltip>Caso nenhuma URL seja fornecida o QRCode irá redirecionar o usuário ao evento</Tooltip>}>
                                    <HelpTooltip icon={faExclamationCircle} />
                                </OverlayTrigger></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="json.apresentation.showQRCode.link"
                                    value={values.json.apresentation.showQRCode.link}
                                    onChange={handleChange}
                                    isInvalid={!!errors.apresentation?.showQRCode?.link}
                                    isValid={
                                        touched.json?.apresentation?.showQRCode?.link &&
                                        !errors.json?.apresentation?.showQRCode?.link
                                    }
                                />
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.link}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                as={Col}
                                sm="4"
                            >
                                <Form.Label>Posição Y</Form.Label>
                                <Form.Select
                                    onChange={(e) => {
                                        setFieldValue("json.apresentation.showQRCode.position.y", e.target.value);
                                    }}
                                    value={values.json.apresentation.showQRCode.position.y}>
                                    <option value={'top'}>
                                        Topo
                                    </option>
                                    <option value={'bottom'}>
                                        Fundo
                                    </option>
                                </Form.Select>
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.position?.y}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                                as={Col}
                                sm="4">
                                <Form.Label>Posição X</Form.Label>
                                <Form.Select
                                    onChange={(e) => {
                                        setFieldValue("json.apresentation.showQRCode.position.x", e.target.value);
                                    }}
                                    value={values.json.apresentation.showQRCode.position.x}>
                                    <option value={'left'}>
                                        Esquerda
                                    </option>
                                    <option value={'right'}>
                                        Direita
                                    </option>
                                </Form.Select>
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.position?.x}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                    ) : (
                        ""
                    )}
                </Form.Group>
            </Row>

            <Row className="mx-0">
                <div className="tab">
                    <Tab.Container id="signature-tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                        <Nav variant="tabs" className="">
                            <Nav.Item>
                                <Nav.Link eventKey={'panel'}>Painel de elementos</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey={'user'} className="mt-3">
                                <Row className="mx-0 mb-3">
                                    <p className="text-start fw-bold mb-2">Configurações do modo usuário</p>
                                    <p className="text-muted">Neste modo, cada usuário visualiza apenas suas próprias assinaturas.</p>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey={'panel'} className="mt-3">
                                <Row className="mx-0 mb-3">
                                    <Form.Group as={Col} sm={4} className='mb-3'>
                                        <Form.Label>Largura dos elementos (px) <OverlayTrigger overlay={<Tooltip>Valor entre 50 e 300</Tooltip>}><HelpTooltip icon={faExclamationCircle} /></OverlayTrigger></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="json.matterPanel.width"
                                            value={values.json.matterPanel.width}
                                            onChange={handleChange}
                                            isInvalid={!!errors.json?.matterPanel?.width}
                                            min={50}
                                            max={300}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.json?.matterPanel?.width}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} sm={4} className='mb-3'>
                                        <Form.Label>Máximo de elementos <OverlayTrigger overlay={<Tooltip>Valor entre 5 e 100</Tooltip>}><HelpTooltip icon={faExclamationCircle} /></OverlayTrigger></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="json.matterPanel.maxElements"
                                            value={values.json.matterPanel.maxElements}
                                            onChange={handleChange}
                                            isInvalid={!!errors.json?.matterPanel?.maxElements}
                                            min={5}
                                            max={100}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.json?.matterPanel?.maxElements}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} sm={4} className='mb-3'>
                                        <Form.Label>Tempo entre adições (ms) <OverlayTrigger overlay={<Tooltip>Valor entre 100 e 5000</Tooltip>}><HelpTooltip icon={faExclamationCircle} /></OverlayTrigger></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="json.matterPanel.timeBetween"
                                            value={values.json.matterPanel.timeBetween}
                                            onChange={handleChange}
                                            isInvalid={!!errors.json?.matterPanel?.timeBetween}
                                            min={100}
                                            max={5000}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.json?.matterPanel?.timeBetween}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                <Row className="mx-0 mb-3">
                                    <Form.Group as={Col} sm={4} className='mb-3'>
                                        <Form.Label>Velocidade do movimento <OverlayTrigger overlay={<Tooltip>Valor entre 0.0001 e 0.002</Tooltip>}><HelpTooltip icon={faExclamationCircle} /></OverlayTrigger></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="json.matterPanel.speed"
                                            step={0.0001}
                                            value={values.json.matterPanel.speed}
                                            onChange={handleChange}
                                            isInvalid={!!errors.json?.matterPanel?.speed}
                                            min={0.0001}
                                            max={0.002}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.json?.matterPanel?.speed}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} sm={4} className='mb-3'>
                                        <Form.Label>Amplitude do movimento (px) <OverlayTrigger overlay={<Tooltip>Valor entre 5 e 100</Tooltip>}><HelpTooltip icon={faExclamationCircle} /></OverlayTrigger></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="json.matterPanel.amplitude"
                                            value={values.json.matterPanel.amplitude}
                                            onChange={handleChange}
                                            isInvalid={!!errors.json?.matterPanel?.amplitude}
                                            min={5}
                                            max={100}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.json?.matterPanel?.amplitude}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Row>
        </>
    );
};

export default SignaturePanel
